module.exports = __webpack_public_path__ + "static/media/primaaff.ca932b3f.webp";